import { faRobot } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { withIcon } from '../../core/components/Icon.tsx';
import classnames from '../../core/utils/classnames.tsx';

const AgentIcon = withIcon(faRobot);

/** Marks a project an inbox agent uses: a small robot with the agent's name (or the icon alone where space is
 *  tight), shown next to the folder that every project carries. Renders nothing for plain shared projects. */
export const ProjectAgentBadge = ({
    project,
    iconOnly = false,
    className,
}: {
    project: { agent?: { name?: string } | null };
    iconOnly?: boolean;
    className?: string;
}) => {
    const { t } = useTranslation('chat');
    if (!project.agent) return null;
    return (
        <span
            title={t('projects.card.agentTitle', { name: project.agent.name })}
            className={classnames(
                'flex flex-none items-center gap-1 text-xs font-medium text-content-medium',
                className
            )}
        >
            <AgentIcon />
            {!iconOnly && project.agent.name}
        </span>
    );
};
